module.exports = __webpack_public_path__ + "img/404.a1f4b138.png";